import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Button,
} from "@mui/material";
import { DeleteDevice } from "./Api";
import { useEffect, useState } from "react";
import ConfirmationDialog from "./S3files/ConfirmationDialog";
import DebugLogsTable from "./DebugLogsTable";
import UpdateTagsModal from "./S3files/UpdateTagsModal";
import { useSelector } from "react-redux";
import { RootState } from "./store";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const DeviceDetailSlider = ({
  open,
  onClose,
  device,
  setSnackbar,
  setSelectedDevice,
  copyEncryptionKey
}: {
  open: boolean;
  onClose: () => void;
  device: any;
  setSnackbar: (snackbar: {
    open: boolean;
    message: string;
    severity: "success" | "error";
  }) => void;
  setSelectedDevice: (device: any) => void;
  copyEncryptionKey?: any;
}) => {
  const { user } = useSelector((state: RootState) => state.user);

  const [openConf, setOpenConf] = useState(false);
  const [onOpenTagsModal, setOpenTagsModal] = useState(false);
  useEffect(() => {}, [openConf]);

  const handleClose = () => {
    setOpenConf(false);
  };

  const handleConfirm = async () => {
    await DeleteDevice(device?.deviceID);
    setOpenConf(false);
    onClose();
  };
  if (!user) return <>loading...</>;

  return (
    <Drawer anchor="right" open={open} onClose={onClose} sx={{ width: 800 }}>
      <Box sx={{ width: 600, padding: 2 }}>
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          sx={{ position: "absolute", top: 10, right: 10 }}
        >
          <CloseIcon />
        </IconButton>
        {user.role === "Admin" && (
          <IconButton edge="end" aria-label="delete">
            <Button
              variant="contained"
              color="error"
              // sx={{ marginLeft: 2 }}
              onClick={() => setOpenConf(true)}
            >
              Delete Device
            </Button>
          </IconButton>
        )}
        {/* <Typography variant="h6">Device Details</Typography> */}
        <List>
          <ListItem>
            <ListItemText
              primary="Device ID"
              secondary={device?.deviceID || "N/A"}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Mac Address"
              secondary={device?.mac_address || "N/A"}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Installation Time"
              secondary={
                device?.installationTime
                  ? device.installationTime.toString()
                  : "N/A"
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Device Type"
              secondary={device?.deviceType || "N/A"}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Firmware Version"
              secondary={device?.firmwareVersion || "N/A"}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Device Status"
              secondary={device?.deviceStatus ? "Running" : "Disconnected"}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Disconnected Time"
              secondary={
                device?.disconnectTime
                  ? device.disconnectTime.toString()
                  : "N/A"
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary="Update Status"
              secondary={device?.updateStatus || "N/A"}
            />
          </ListItem>
          {copyEncryptionKey &&<ListItem>
            <ListItemText
              primary="Copy Encryption Key"
              secondary={<IconButton
              size="small"
              color="primary"
              onClick={() => {
                copyEncryptionKey(device.encryption_key);
              }}
            >
              <ContentCopyIcon />
            </IconButton>}
              />
          </ListItem>}
          <ListItem>
            <ListItemText
              primary="Update Progress"
              secondary={
                device?.updateProgress != null
                  ? `${device.updateProgress}%`
                  : "N/A"
              }
            />
          </ListItem>
          <ListItem>
            <Box
              sx={{ display: "flex", flexDirection: "column", width: "100%" }}
            >
              <Typography variant="subtitle1" sx={{ marginBottom: 1 }}>
                Tags
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {device?.tags && device.tags.length > 0 ? (
                    device.tags.map(
                      (tag: { key: string; value: string }, index: number) => (
                        <Chip
                          key={index}
                          label={`${tag.key}: ${tag.value}`}
                          variant="outlined"
                        />
                      )
                    )
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No tags
                    </Typography>
                  )}
                </Box>
                <Button
                  variant="contained"
                  sx={{ marginLeft: 2 }}
                  onClick={() => setOpenTagsModal(true)}
                >
                  Update Tags
                </Button>
              </Box>
            </Box>
          </ListItem>
          <ListItem>
            <ListItemText primary="Debug Logs" />
          </ListItem>
        </List>
        <Box sx={{ marginTop: 2 }}>
          <DebugLogsTable logs={device?.errorLogs || []} />
        </Box>
      </Box>
      <ConfirmationDialog
        open={openConf}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        title="Delete Confirmation"
        description="Are you sure you want to delete this Device? This action cannot be undone."
      />
      {/* <Spinner running={true} /> */}
      <UpdateTagsModal
        openModal={onOpenTagsModal}
        setOpenModal={setOpenTagsModal}
        currentTags={device?.tags}
        deviceID={device?.deviceID}
        setSnackbar={setSnackbar}
        device={device}
        setSelectedDevice={setSelectedDevice}
      />
    </Drawer>
  );
};

export default DeviceDetailSlider;
